

/**
 * This hook will identify whether an user logged in or not
 */

import StorageService from "../services/storage/storage.service"
import { useAppSelector } from "../store/storeRequests"
import StoreSelectors from "../utils/constants/StoreSelectors.constants"

const useAuth = () => {
    /**
     *  0 - not logged in
     *  1 - logged in
     *  2 - token exists in local storage - Need to fetch other user details
     */
    const { user } = StorageService.getFromStorage(['user'])
    // const { userBasic, moduleAccess } = useAppSelector(StoreSelectors.USER_STATE)
    const { userBasic } = useAppSelector(StoreSelectors.USER_STATE)
// console.log(user)
    try {

        /** Required values to check state values  */
        // const RequiredProperties: Array<'user_id' | 'email' | 'token'> = ['user_id', 'email', 'token']

        let authStatus: 0 | 1 | 2 = 1

        /** Check local storage values */
        if (typeof user === 'undefined') {
            // console.log("User is undefined");
            return 0
        } else if (typeof user['token'] !== 'string') {
            return 0
        }

        /** Check char length of redux user reducer values */
        // for (let item in RequiredProperties) {
        //     if (userBasic[RequiredProperties[item]].length === 0) {
        //         // console.log(userBasic[RequiredProperties[item]])
        //         authStatus = 2
        //         break
        //     }
        // }

        /** Check module access details */
        // if (moduleAccess.length === 0) {
        //     authStatus = 2
        // }

        return authStatus

    } catch (error) {
        console.log(error);
        return 0
    }

}

export default useAuth